<template>
  <div class="guests">
    <small>
      Wpisz nazwiska gości lub wklej listę - każdy wiersz to kolejna pozycja. Dodaj dowolną ilość pozycji z kropkami lub pustymi polami, jeśli chcesz wypisać produkty własnoręcznie.
    </small>
    <ul class="items">
      <li v-for="(item, index) in scene.guests" :class="{ 'active': index == previewGuestIndex}" :key="index" @click="handleGuestClick(index)">
        {{ index + 1 }}. {{ item.display }}
        <span class="buttons">
          <i class="duplicate el-icon-document-copy" @click.stop="handleDuplicateGuest(index)" />
          <i class="close el-icon-close" @click.stop="handleRemoveGuest(index)" />
        </span>
      </li>
    </ul>
    <el-form class="guest-form" ref="form" :model="guests" label-width="220px">
        <el-form-item label-width="0">
          <textarea
            id="guestField"
            ref="guestField"
            placeholder="Uzupełnij ręcznie lub wklej listę i potwierdź ENTER"
            v-model="guests.value"
            :disabled="isBlocked"
            @keyup.enter="saveGuests"
            @blur="saveGuests"
          />
        </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Editor from '../../classes/Editor'

export default {
  name: 'Guests',
  props: ['sceneIndex'],
  data() {
    return {
      guests: {
        value: '',
      },
    };
  },
  computed: {
    ...mapGetters('creator', ['scene', 'previewGuest', 'previewGuestIndex', 'isPreview', 'isBlocked']),
  },
  methods: {
    ...mapActions('creator', ['setSceneGuests', 'removeSceneGuest', 'setPreviewGuest', 'setPreviewGuestIndex']),

    saveGuests() {
      if (!this.guests.value.length) {
        return
      }

      const guests = this.guests.value.split(/\r\n|\n|\r/)
                         .filter((item) => item.length)
                         .map((item) => ({
                           x: 0,
                           y: 0,
                           content: item,
                           display: item 
                         }));

      this.setSceneGuests({
        scene: this.sceneIndex,
        guests: [...(this.scene.guests || []), ...guests],
      });
      this.guests.value = '';
      this.handleGuestClick(this.scene.guests.length - 1)
    },
    handleDuplicateGuest(guestIndex) {
      this.setSceneGuests({
        scene: this.sceneIndex,
        guests: [...this.scene.guests.slice(0, guestIndex), this.scene.guests[guestIndex], ...this.scene.guests.slice(guestIndex, this.scene.guests.length)],
      });
    },
    handleRemoveGuest(guestIndex) {
      this.removeSceneGuest({
        scene: this.sceneIndex,
        guestIndex
      })

      // If no guests clsoe preview mode
      if (!this.scene.guests.length) {
        this.setPreviewGuestIndex(null)
        Editor.setPreview(null)
      } else {
        // Get prev guest inde for set active name
        const prevGuestIndex = guestIndex - 1
        
        this.setPreviewGuestIndex(prevGuestIndex < 0 ? 0 : prevGuestIndex);
        Editor.setPreview(this.previewGuest, false)
      }
    },
    handleGuestClick(guestIndex) {
      this.setPreviewGuestIndex(guestIndex);
      Editor.setPreview(this.previewGuest, false)
    },
  },
};
</script>

<style lang="less">
.el-input-number.is-controls-right {
  width: 70px;
  max-width: 70px;
  .el-input__inner {
    padding-right: 35px;
    padding-left: 5px;
  }
}

textarea {
  width: 100%;
  max-width: 100%;
  border: 1px solid #ccc;
  padding: 5px 10px;
  box-sizing: border-box;
  border-radius: 3px;
  margin-top: 10px;
  &::placeholder {
    font: 12px/16px 'Raleway';
  }
}
.items {
  list-style: none;
  margin: 10px 0;
  padding: 0;
  max-height: 150px;
  overflow: auto;

  li {
    padding: 5px 10px;
    background: #f4f4f5;
    color: #909399;
    border-radius: 3px;
    font-size: 13px;
    cursor: pointer;
    transition: background .3s;
    display: flex;
    align-items: center;

    &:hover {
      background: #eee;
    }

    &.active {
      color: #fff;
      background: #e6a23c;
    }

    .buttons {
      margin-left: auto;
    }

    .close {
      cursor: pointer;
      padding: 0 5px;
    }
    
    + li {
      margin-top: 5px;
    }
  }
}
</style>
